import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Location } from '@angular/common';
import { InspectionSectionService } from '../../shared/services/index';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { BaseModalPageComponent } from '../../base-modal.component';

@Component({
    templateUrl: './edit-json.component.html',
    standalone: false
})
export class SectionEditJsonPageComponent extends BaseModalPageComponent implements OnInit {
  section: any;
  sectionId: string;
  inspectionId: string;
  public processing = false;

  constructor(
    public sectionService: InspectionSectionService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    location: Location,
    private cdf: ChangeDetectorRef
  ) {
    super(location);
  }

  ngOnInit(): void {
    this.initRoute();
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.inspectionId = id;

      const sectionId = params['sectionId'];
      if (sectionId == null) this.router.navigate([this.inspectionsRoute, this.inspectionId]);

      this.sectionId = sectionId;
      this.initData();
    });
  }

  saveInspectionSection(object: any): void {
    this.processing = true;
    this.sectionService.updateSectionEntity(this.inspectionId, this.sectionId, object).subscribe((res) => {
      this.goToBack();
    });
  }

  cancel(): void {
    this.goToBack();
  }

  initData(): void {
    this.sectionService.getSectionEntity(this.inspectionId, this.sectionId).subscribe((el) => {
      this.section = el;
      this.cdf.detectChanges();
    });
  }
}
